import "../style/floating.css";
import Kakao from "../assets/kakao.png";
import Instagram from "../assets/instagram.png";
import Naver from "../assets/naver.png";
import Blog from "../assets/blog.png";
import {KeyboardArrowRight} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";

const Floating = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      {location.pathname !== '/apply' && location.pathname !== '/admin' && (
        <div className={'floating-apply'}
             onClick={() => navigate("/apply")}>
        <span>
          강습 신청 바로가기
        </span>
          <KeyboardArrowRight/>
        </div>
      )}
      <div className={'floating'} style={{visibility: location.pathname === '/admin' ? 'hidden' : 'visible'}}>
        <img className={'floating-icon'} src={Kakao} alt={'카카오톡 플러스친구'}
             onClick={() => window.open("http://pf.kakao.com/_xnSjVn", "_blank")}/>
        <img className={'floating-icon'} src={Instagram} alt={'인스타그램'}
             onClick={() => window.open("https://www.instagram.com/Blue_skischool", "_blank")}/>
        <img className={'floating-icon'} src={Naver} alt={'네이버 스마트스토어'}
             onClick={() => window.open("https://m.smartstore.naver.com/blueskischool9598", "_blank")}/>
        <img className={'floating-icon'} src={Blog} alt={'네이버 블로그'}
             onClick={() => window.open("https://m.blog.naver.com/PostList.naver?blogId=blueski9596&tab=1", "_blank")}/>
      </div>
    </>
  )
}

export default Floating;